var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLastViewedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7309_5111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1733 8.82455L8.08184 7.25599V4.06082C8.08184 3.73955 7.82215 3.47986 7.50088 3.47986C7.17961 3.47986 6.91992 3.73955 6.91992 4.06082V7.5465C6.91992 7.72949 7.00591 7.90205 7.1523 8.01127L9.47607 9.75411C9.58063 9.83254 9.70266 9.8703 9.82406 9.8703C10.0012 9.8703 10.1755 9.7907 10.2894 9.63733C10.4823 9.3811 10.43 9.01685 10.1733 8.82455Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C3.36425 0 0 3.36425 0 7.5C0 11.6358 3.36425 15 7.5 15C11.6358 15 15 11.6358 15 7.5C15 3.36425 11.6358 0 7.5 0ZM7.5 13.8381C4.00562 13.8381 1.16188 10.9944 1.16188 7.5C1.16188 4.00562 4.00562 1.16188 7.5 1.16188C10.995 1.16188 13.8381 4.00562 13.8381 7.5C13.8381 10.9944 10.9944 13.8381 7.5 13.8381Z",
    fill: "#989898"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7309_5111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastViewedIcon);
export default __webpack_public_path__ + "static/media/lastViewedIcon.be6dbc5e6ee842550f8c352929068a82.svg";
export { ForwardRef as ReactComponent };